<template>
  <div>
    <modal-header
        :title="title"
        @close="close"
        @search="search"
        ref="modalHeader"
    ></modal-header>
    <div class="add-box clearfix">
      <vxe-table
          show-overflow
          highlight-hover-row
          stripe
          border="none"
          ref="xTable"
          class="table-style"
          :max-height="accountCate == 'platform' ? 530 : 500"
          align="center"
          :auto-resize="true"
          :data="tableData"
          @cell-click="cellClick"
      >
        <vxe-table-column
            field="companyName"
            title="企业名称"
            v-if="accountCate == 'platform'"
        ></vxe-table-column> 
        <vxe-table-column field="accountName" title="户名"></vxe-table-column>
        <vxe-table-column field="bankName" title="开户行" v-if="accountCate == 'platform'"></vxe-table-column>
        <vxe-table-column field="openBankName" title="开户行" v-if="accountCate == 'user'"></vxe-table-column>
        <vxe-table-column field="accountNum" title="账户号"></vxe-table-column>
        <vxe-table-column
            field="bankAccountType"
            title="账户类型"
            v-if="accountCate == 'platform'"
        >
          <template v-slot="{ row }">
            <div>{{ row.bankAccountType | bankAccountType }}</div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="getBankAccountList"
          v-if="accountCate == 'user'"
      ></vxe-pager>
    </div>
  </div>
</template>
<script>
  import {apiRequest} from "@/utils/api";
  import ModalHeader from "@/components/common/ModalHeader";

  const empties = [undefined, "", null, "null", {}, []];

  export default {
    name: "BankAccount",
    components: {
      ModalHeader,
    },
    data() {
      return {
        accountCate: "",
        accountName: "",
        title: "",
        tableData: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        field: "",
        obj: null,
        orderType: null,
      };
    },
    filters: {
      bankAccountType(val) {
        if (val != null) {
          if (val === 1) {
            return "现金账户"
          }
          if (val === 2) {
            return "银行账户（一般户）"
          }
          if (val === 3) {
            return "银行账户（基本户）"
          }
          if (val === 4) {
            return "汇票账户"
          }
        }
      }
    },
    methods: {
      init(accountCate, field, obj) {
        this.accountCate = accountCate;
        this.title =
          accountCate == "platform" ? "选择平台银行账户" : "选择用户银行账户";
        this.page.currentPage = 1;
        this.accountName = "";
        this.field = field;
        this.obj = obj;
        // console.log(this.obj, '123');
        // debugger
        this.orderType = obj ? obj.paymentType : '';

        this.$refs.modalHeader.clear();
        this.getBankAccountList();
      },
      search(word) {
        this.page.currentPage = 1;
        this.accountName = word;
        this.getBankAccountList();
      },
      async searchByUserId(id) {
        this.accountName = null;
        let params = {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          userType: 0,
          userId: id
        };
        let res = await apiRequest(
          "api/auth/",
          "baseUserSign/queryUserBankList",
          params
        );
        this.tableData = res.data.rows;
        this.page.totalResult = res.data.total;
      },
      async getBankAccountList() {
        let params = {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          userType: 0,
        };
        if (!empties.includes(this.accountName)) {
          params.accountName = this.accountName;
        }
        let res;

        // if (this.field == "paymentsName" && this.orderType === 2) {
        //   // console.log(this.field, 'this.obj');
        //   // debugger
        //   params.companyName = this.obj.compName;
        //   res = await apiRequest(
        //     "api/order/",
        //     "platform_corp/getPlatformCompanyList",
        //     params
        //   );
        //   this.isShow = true;
        //   this.tableData = res.data;
        // } else {
        //   if (this.field == "paymentsName") {
        //     // 实际承运人订单 付款企业
        //     params.userId = this.obj.ordersList[0].sellerIdLv2;
        //   } else {
        //    params.userId = this.obj.ordersList[0].sellerId;
        //   }

        //   res = await apiRequest(
        //     "api/auth/",
        //     "baseUserSign/queryUserBankList",
        //     params
        //   );
        //   this.isShow = false;
        //   this.tableData = res.data.rows;
        //   this.page.totalResult = res.data.total;
        // }
        // 2020-11-17  收款人和付款人添加过滤
        if (this.accountCate == "platform") {
          // 平台企业
          params.companyName = this.obj ? this.obj.compName : '';
          res = await apiRequest(
            "api/order/",
            "platform_corp/getPlatformCompanyList",
            params
          );
          this.tableData = res.data;
        } else {
          // 用户
          // console.log(this.obj, "adf");
          // debugger;
          if (this.orderType === 3) {
            if (this.field == "paymentsName") {
              // 实际承运人订单 付款企业
              params.userId = this.obj ? this.obj.ordersList[0].sellerId : null;
            } else {
              // 实际承运人订单 收款企业
              params.userId = this.obj ? this.obj.ordersList[0].sellerIdLv2 : null;
            }
          } else if (this.orderType === 1) {
            // 托运人订单 付款企业
            params.userId = this.obj ? this.obj.ordersList[0].buyerId : null;
          } else {
            params.userId = this.obj ? this.obj.ordersList[0].sellerId : null;
          }


          res = await apiRequest(
            "api/auth/",
            "baseUserSign/queryUserBankList",
            params
          );
          this.tableData = res.data.rows;
          this.page.totalResult = res.data.total;
        }
        console.log(this.tableData);
      },
      cellClick({row}) {
        this.$emit("choose", row);
      },
      close() {
        this.$emit("close");
      },
    },
  };
</script>